import { atom, RecoilState } from "recoil"
import { UserDetail } from "../connector/type";

export interface MyInfo {
  id: string;
  ownRoomId: string | null;
  userDetail: UserDetail | null;
  bullet: number;
  standardTicket: number;
  premiumTicket: number;
}

const defaultUserDetail: UserDetail = {
  id: '',
  nickname: '',
  level: 1,
  hasThumbnail: false,
  todayComment: '',
  gasMask: false,
  familyNickname: '',
}

const defaultMyInfo: MyInfo = {
  id: '',
  ownRoomId: '',
  userDetail: defaultUserDetail,
  bullet: 0,
  standardTicket: 0,
  premiumTicket: 0,
};

const myInfoState: RecoilState<MyInfo> = atom({
  key: 'myInfo',
  default: defaultMyInfo,
});

export default myInfoState;